/**
 * I path con token segreto nell'URL (link referral, inviti, portali, download
 * firmati) non devono finire in analytics o crash-report: il segmento
 * variabile è sostituito da un placeholder letterale, così la pagina resta
 * riconoscibile senza esporre il token.
 */
const TOKENIZED_PATH =
  /^\/(signup-link|invite|admin-invite|wa|ispezione|richiesta|public\/haccp-archive|public\/billing)\/[^/?#]+/;

export function sanitizeTokenizedPath(path: string): string {
  return path.replace(TOKENIZED_PATH, '/$1/:token');
}

export function isTokenizedPath(path: string): boolean {
  return TOKENIZED_PATH.test(path);
}
